import { CoreEnvironment } from './core-environment.type';

export const environment: CoreEnvironment = {
  name: 'testing',
  production: false,
  showEnvironmentInformation: true,
  newsLayoutColumns: 3,
  nestJSBackendUrl: 'http://localhost:3000',
  tenantMode: 'SINGLE_TENANT',
};
